function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { prevDate, prevMonth, prevYear } from '@bydesign-ui/utils';
import { isDynamicDateRange } from '../dynamic-date-range-panel/util';
export var dynamicDateConverters = {
  day: prevDate,
  week: function week(pivot, offset) {
    return prevDate(pivot, offset * 7);
  },
  month: prevMonth,
  quarter: function quarter(pivot, offset) {
    return prevMonth(pivot, offset * 3);
  },
  year: prevYear
};
export function dynamicDateToDynamicDateRange(dynamicDate) {
  var offset = dynamicDate.offset,
      others = _objectWithoutProperties(dynamicDate, ["offset"]);

  return _objectSpread(_objectSpread({}, others), {}, {
    offsets: [offset, offset]
  });
}
export function dynamicDatePresetToDynamicDateRangePreset(dynamicDatePreset) {
  return dynamicDateToDynamicDateRange(dynamicDatePreset);
}
export function fixedDateToFixedDateRange(fixedDate) {
  var value = fixedDate.value,
      others = _objectWithoutProperties(fixedDate, ["value"]);

  return _objectSpread(_objectSpread({}, others), {}, {
    value: [value, value]
  });
}
export function fixedDatePresetToFixedDateRangePreset(fixedDatePreset) {
  var value = fixedDatePreset.value,
      others = _objectWithoutProperties(fixedDatePreset, ["value"]);

  return _objectSpread(_objectSpread({}, others), {}, {
    value: [value, value]
  });
}
export function isDynamicDate(val) {
  return val.type === 'dynamic';
}
export function dynamicDateValueToDynamicDateRangeValue(dynamicDateValue) {
  if (isDynamicDate(dynamicDateValue)) {
    return dynamicDateToDynamicDateRange(dynamicDateValue);
  }

  return fixedDateToFixedDateRange(dynamicDateValue);
}
export function dynamicDateRangeValueToDynamicDateValue(dynamicDate) {
  if (isDynamicDateRange(dynamicDate)) {
    var offsets = dynamicDate.offsets,
        _others = _objectWithoutProperties(dynamicDate, ["offsets"]);

    return _objectSpread(_objectSpread({}, _others), {}, {
      offset: offsets[0]
    });
  }

  var value = dynamicDate.value,
      others = _objectWithoutProperties(dynamicDate, ["value"]);

  return _objectSpread(_objectSpread({}, others), {}, {
    value: value[0]
  });
}